import Image from "next/legacy/image";
import Photo from 'wwg-utilities/dist/collections/photo';
import Program from 'wwg-utilities/dist/collections/program';
import Provider from 'wwg-utilities/dist/collections/provider';
// import Provider from 'wwg-utilities/dist/collections/provider';

interface SmallImageProps {
  program: Program;
  smallImage: string;
}

const SmallImage: React.FC<SmallImageProps> = ({ smallImage, program }) => {
  return (
    <Image
      className="object-cover w-screen max-w-screen md:w-full md:h-auto lg:mx-0"
      src={smallImage || (program.image as Photo).cloudinaryURL || ''}
      blurDataURL={smallImage || (program.image as Photo).cloudinaryURL}
      layout="responsive"
      loading="eager"
      placeholder="blur"
      width={1000}
      height={975}
      alt={`${program.name} at ${(program.institution as Provider).name}`}
    />
  );
};

export default SmallImage;
